export default "__VITE_ASSET__DiZ0cWGZ__"